@defer (when isBrowser) {
  <jp-navigation-progress-bar />
}
<router-outlet />
